import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getProfessionalQualifications } from "../../slices/codeBookSlice";

export const useGetProfessionalQualifications = () => {
  const professionalQualifications = useSelector(
    (state: RootState) => state.codeBook.professionalQualifications
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProfessionalQualifications());
  }, [dispatch]);

  return professionalQualifications;
};
